<template>
  <div id="app">
    <!--<router-view/>-->
    <transition :name="transitionName">
      <keep-alive :include="keepAlive">
        <router-view class="Router"></router-view>
      </keep-alive>
      </transition>
    <div v-wechat-title="$route.name"></div>
  </div>
</template>
<script>
  export default {
    name: 'app',
    data() {
      return {
        // 默认动态路由变化为slide-right
        transitionName: 'slide-right',
        keepAliveList: [
          'retail-category',
        ],
        keepAlive: '',
      }
    },
    watch:{
      '$route' (to) {
        if(to.name === '美书') {
          this.transitionName = 'slide-right'
        } else {
          this.transitionName = 'slide-left'
        }
      }
    },
    mounted() {
      this.keepAlive = this.keepAliveList.join(',');
    }
  }
</script>

<style>
  * {
    margin: 0;
    padding: 0;
  }
  
  html,
  body,
  #app {
    background: #f5f5f5;
    width: 100%;
  }
  
  .container {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  
  .container2 {
    display: flex;
    flex-direction: column;
    height: 700px;
  }
  
  a {
    text-decoration: none;
    color: black;
  }
  
  *:focus {
    outline: none;
  }
  
  .Router {
    position: absolute;
    width: 100%;
    transition: all .8s ease;
  }
  
  .slide-left-enter,
  .slide-right-leave-active {
    opacity: 0;
    transform: translate(100%, 0);
  }
  
  .slide-left-leave-active,
  .slide-right-enter {
    opacity: 0;
    transform: translate(-100% 0);
  }
  .van-tabs--line .van-tabs__wrap {
    height: 1.2rem !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue